import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { MotionProvider } from "@/components/MotionProvider";
import { lazy, Suspense } from "react";
import Index from "./pages/Index";

// Lazy load non-critical routes to reduce initial bundle size
const Auth = lazy(() => import("./pages/Auth"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Projects = lazy(() => import("./pages/Projects"));
const CreateProject = lazy(() => import("./pages/CreateProject"));
const ProjectView = lazy(() => import("./pages/ProjectView"));
const ProjectSettings = lazy(() => import("./pages/ProjectSettings"));
const Settings = lazy(() => import("./pages/Settings"));
const Billing = lazy(() => import("./pages/Billing"));
const AdminDashboard = lazy(() => import("./pages/admin/Dashboard"));
const FigmaToReact = lazy(() => import("./pages/FigmaToReact"));
const FigmaToVue = lazy(() => import("./pages/FigmaToVue"));
const Blog = lazy(() => import("./pages/Blog"));
const FigmaToDevWorkflow = lazy(() => import("./pages/blog/FigmaToDevWorkflow"));
const DesignDocumentationBestPractices = lazy(() => import("./pages/blog/DesignDocumentationBestPractices"));
const CaseStudyStartup = lazy(() => import("./pages/blog/CaseStudyStartup"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <MotionProvider>
        <TooltipProvider>
          <div>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <Suspense fallback={<div className="flex items-center justify-center min-h-screen">Loading...</div>}>
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/auth" element={<Auth />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/projects" element={<Projects />} />
                  <Route path="/projects/new" element={<CreateProject />} />
                  <Route path="/projects/:id" element={<ProjectView />} />
                  <Route path="/projects/:id/settings" element={<ProjectSettings />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/billing" element={<Billing />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/figma-to-react" element={<FigmaToReact />} />
                  <Route path="/figma-to-vue" element={<FigmaToVue />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/figma-to-dev-workflow" element={<FigmaToDevWorkflow />} />
                  <Route path="/blog/design-documentation-best-practices" element={<DesignDocumentationBestPractices />} />
                  <Route path="/blog/case-study-startup-success" element={<CaseStudyStartup />} />
                  {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Suspense>
            </BrowserRouter>
          </div>
        </TooltipProvider>
      </MotionProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
